import React from "react";
import { Box, Switch, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CustomSwitch = ({ leftLabel, rightLabel, value, onChange }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "left",
        ml:1,
        flexDirection: "row",
        mt: 1,
      }}
    >
      {/* Lógica para switches con UN solo label (ej: PROPINA y CASHBACK) */}
      {leftLabel && !rightLabel && (
        <>
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: !value ? "normal" : "bold",
              color: value ? theme.bandera.colorPrimario : "gray", // Cambia color según el estado
              transition: "color 0.3s ease-in-out",
            }}
          >
            {leftLabel}
          </Typography>
          <Switch checked={value} onChange={onChange} color="primary" />
        </>
      )}

      {/* Lógica para switches con DOS labels (ej: LISTA QRS / QR INDIVIDUAL) */}
      {leftLabel && rightLabel && (
        <>
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: !value ? "bold" : "normal",
              color: !value ? theme.bandera.colorPrimario : "gray",
              transition: "color 0.3s ease-in-out",
            }}
          >
            {leftLabel}
          </Typography>

          <Switch checked={value} onChange={onChange} color="primary" />

          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: value ? "bold" : "normal",
              color: value ? theme.bandera.colorPrimario : "gray",
              transition: "color 0.3s ease-in-out",
            }}
          >
            {rightLabel}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default CustomSwitch;
